import React from 'react';
export const BolderArrowForth = ({ title, ...rest }) => (
  <svg viewBox="0 0 500 500" {...rest}>
    {title && <title>{title}</title>}
    <path d="M174.6 500c-8.3 0-16.7-3.2-23-9.5-12.7-12.7-12.7-33.4 0-46.1L345.9 250 151.5 55.7c-12.7-12.7-12.7-33.4 0-46.1s33.4-12.7 46.1 0L438.1 250 197.6 490.4c-6.4 6.4-14.7 9.6-23 9.6z" />
  </svg>
);
